// AccessDenied.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Result, Button, Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher from '../../../components/auth/LanguageSwitcher';

const AccessDenied: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Layout
            style={{
                minHeight: '100vh',
                position: 'relative',
            }}
        >
            {/* Language Switcher - Top Right */}
            <div
                style={{
                    position: 'absolute',
                    top: 24,
                    right: 24,
                    zIndex: 1000,
                }}
            >
                <LanguageSwitcher variant="dark" />
            </div>
            <Result
                status="403"
                title="403"
                subTitle={t('message.access_denied')}
                extra={
                    <Button type="primary" onClick={() => navigate('/')}>
                        {t('button.back_home')}
                    </Button>
                }
            />
        </Layout>
    );
};

export default AccessDenied;
